/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Scope_UnknownInputs */

const en_adm_scope_unknown = /** @type {(inputs: Adm_Scope_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(deleted)`)
};

const de_adm_scope_unknown = /** @type {(inputs: Adm_Scope_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(gelöscht)`)
};

/**
* | output |
* | --- |
* | "(deleted)" |
*
* @param {Adm_Scope_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_scope_unknown = /** @type {((inputs?: Adm_Scope_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Scope_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_scope_unknown(inputs)
	return en_adm_scope_unknown(inputs)
});